import React, { useEffect, useState, Suspense } from 'react';
import config from 'react-global-configuration';
import { useTranslation } from 'react-i18next';
import Immutable from 'immutable';
import qs from 'query-string';

import { formatMoneyFromString } from '../../../../helpers';

import HighchartComponent from './HighchartComponent';

import './style.scss';

const options = {
  chart: {
    type: 'pie',
    style: {
      fontFamily: 'Arial',
      fontSize: 12,
    },
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
  title: {
    text: '',
    align: 'center',
    verticalAlign: 'middle',
    style: {
      color: '#000',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontSize: 14,
    },
  },
  colors: [
    '#63A9FE',
    '#DD2C32',
    '#FFF18E',
    '#93D25F',
    '#7643CC',
    '#FEA746',
    '#865457',
    '#A7BD91',
    '#00CCFF',
    '#CDFFFE',
    '#D6FDCE',
  ],
  plotOptions: {
    series: {
      dataLabels: {
        enabled: false,
      },
      innerSize: '70%',
    },
    pie: {
      dataLabels: {
        distance: -30,
        color: 'white',
        format: '{percentage:.1f}%',
      },
      borderWidth: 0,
      allowPointSelect: true,
      size: 320,
    },
  },
  tooltip: {
    enabled: true,
    useHTML: false,
    pointFormat: '\u20ac {point.y} ({point.percentage:.1f}%)',
  },
  legend: {
    enabled: false,
    title: {
      text: 'Programma',
      style: {
        fontWeight: 'bold',
        fontStyle: 'normal',
      },
    },
    verticalAlign: 'middle',
    layout: 'vertical',
    itemStyle: {
      fontWeight: 'normal',
      fontStyle: 'normal',
    },
  },
  credits: {
    enabled: false,
  },
  series: [
    {
      name: 'Bedrag',
      marker: {
        radius: 3,
      },
      showInLegend: true,
      connectNulls: true,
      tooltip: [],
      data: [],
    },
  ],
};

const doRequest = (filters) => {
  const API_URL = config.get('API_URL');

  const queryParams = qs.stringify({
    year: filters.field_date_value ? filters.field_date_value.value : null,
    locality: filters.field_address_locality ? filters.field_address_locality : null,
    area: filters.term_node_tid_depth ? filters.term_node_tid_depth : null,
  }, {
    skipNull: true,
  });

  const url = `${API_URL}/api/awards/totals?${queryParams}`;
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((response) => { return response.json(); })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const AwardGraph = ({ filters }) => {
  const { t } = useTranslation();
  const [results, setResults] = useState(Immutable.Map());

  useEffect(() => {
    doRequest(filters)
      .then((data) => {
        setResults(Immutable.fromJS(data));
      });
  }, [filters]);

  let total = 0;
  options.series[0].data = [];
  results.valueSeq().forEach((key) => {
    const name = key.get('name') ? key.get('name') : t('awards.category.miscellaneous');

    options.series[0].data.push([name, parseFloat(key.get('sum'))]);
    total += parseFloat(key.get('sum'));
  });

  options.title.text = formatMoneyFromString(total);

  return (
    <div className="Graph">
      {
        results.size > 0 && (
          <HighchartComponent key={options.title.text} options={options} />
        )
      }
    </div>
  );
};

export default AwardGraph;
